import React, { useEffect, useState, useRef } from 'react'
import { Container, Row, Col, Card, Button, Modal, Spinner } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
// import useAuth from '../../context/auth/useAuth'
import { Link, useNavigate, useParams } from 'react-router-dom'
// import { addPaymentIntent, getOrder } from '../../actions/ordersActions'
import { getOrder, getPaymentFormParams, getPaymentStatus } from '../../actions/ordersActions'
import Swal from 'sweetalert2'
// import {Elements} from '@stripe/react-stripe-js'
// import { StripeCheckoutForm } from '../../components/payment/StripeCheckoutForm'
// import { loadStripe } from '@stripe/stripe-js'
// import Axios from 'axios'


export default function PayOrder() {
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const navigate = useNavigate()
	// const {client} = useAuth()

    const { orderId } = useParams()

	const {order, formParams, paymentStatus} = useSelector(state=>state.orders)

	// const [stripePromise, setStripePromise] = useState(null)
    // const [clientSecret, setClientSecret] = useState("")

	
    const [waitingForPayment, setWaitingForPayment] = useState(false)
    const [elapsedSeconds, setElapsedSeconds] = useState(0)
    const elapsedIntervalRef = useRef(null)
    const formRef = useRef(null)
    const autoPayTriggered = useRef(false)

	const [redsysParamsState, setRedsysParamsState] = useState(null)

	const [urlPago, setUrlPago] = useState('')

	useEffect(() => {
		window.scrollTo({
            top:0,
            behavior: 'instant'
        })
		if(orderId){
			dispatch(getOrder(orderId))
			setUrlPago(process.env.REACT_APP_DOMAIN_URL+"/payorder/"+orderId)
		}
	},[dispatch, orderId])

	useEffect(() => {
		if (formParams) {
			if (formParams?.params) {
				setRedsysParamsState(formParams.params)
				dispatch({ type: 'ORDER_GET_PAYMENT_FORM_RESET' })
			} else {
				Swal.fire({
					showConfirmButton: true,
					icon: 'danger',
					text: t('client.orders.' + formParams?.message)
				})
			}
		}
	}, [formParams, dispatch, t])

	useEffect(() => {
		if (order?.isPaid === false) {
			dispatch(getPaymentFormParams(order._id))
		}
	}, [order, dispatch])

	useEffect(() => {
		if (paymentStatus?.isPaid || paymentStatus?.paymentStatus) {
			clearInterval(window.orderPaymentStatusInterval)
			setWaitingForPayment(false)
			dispatch({ type: 'ORDER_GET_PAYMENT_STATUS_RESET' })
            navigate('/client/pendingorders')
		}
	}, [paymentStatus, dispatch, navigate])

	useEffect(() => {
		if (waitingForPayment) {
			setElapsedSeconds(0)
			elapsedIntervalRef.current = setInterval(() => {
				setElapsedSeconds(s => s + 1)
			}, 1000)
		} else {
			clearInterval(elapsedIntervalRef.current)
			setElapsedSeconds(0)
		}
		return () => clearInterval(elapsedIntervalRef.current)
	}, [waitingForPayment])

	// Auto-initiate payment when Redsys params are ready
	useEffect(() => {
		if (redsysParamsState && !autoPayTriggered.current) {
			autoPayTriggered.current = true
			setWaitingForPayment(true)
			window.orderPaymentStatusIntervalIndex = 0
			window.orderPaymentStatusInterval = setInterval(() => {
				window.orderPaymentStatusIntervalIndex++
				dispatch(getPaymentStatus(orderId))
				if (window.orderPaymentStatusIntervalIndex > 600) {
					clearInterval(window.orderPaymentStatusInterval)
					setWaitingForPayment(false)
					dispatch({ type: 'ORDER_GET_PAYMENT_STATUS_RESET' })
				}
			}, 1000)
			if (process.env.REACT_APP_PLATFORM === 'app') {
				window.open(process.env.REACT_APP_DOMAIN_URL + '/payorder/' + orderId, '_system')
			} else if (formRef.current) {
				formRef.current.submit()
			}
		}
	}, [redsysParamsState, orderId, dispatch])

	const handleCancelPayment = () => {
		clearInterval(window.orderPaymentStatusInterval)
		setWaitingForPayment(false)
		dispatch({ type: 'ORDER_GET_PAYMENT_STATUS_RESET' })
	}

	const handleCheckNow = () => {
		dispatch(getPaymentStatus(orderId))
	}

	const PAYMENT_TIMEOUT = 600
	const remainingSeconds = Math.max(0, PAYMENT_TIMEOUT - elapsedSeconds)
	const formatCountdown = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`

	// useEffect(() => {
	// 	const getStripeParams = async () => {
    //         const {data} = await Axios.get(process.env.REACT_APP_DB_ADDRESS + '/api/payment/config', {
    //             headers: { auth: localStorage.getItem('jwt') }
    //         })
    //         return (loadStripe(data?.publishableKey))
    //     }
	// 	if (!order?.idPaid) {
	// 		setStripePromise(getStripeParams())
	// 	}
	// }, [orderId, order])

	// useEffect(() => {
	// 	const getClientSecret = async (order) => {
    //         const {data} = await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/payment/createpaymentintent', {
	// 			user: client.id,
    //             amount: (order?.price * 100).toFixed(0)
    //         }, {
    //             headers: { auth: localStorage.getItem('jwt') }
    //         })
    //         setClientSecret(data?.clientSecret)
    //         dispatch(addPaymentIntent(order?.id || order?._id, data?.clientSecret?.split('_secret_')[0]))
    //     }

	// 	if (order) {
	// 		getClientSecret(order)
	// 	}
	// }, [order, client, dispatch])

	const handlePaymentLinkClick = () => {

		if (!waitingForPayment) {
			setWaitingForPayment(true)

			const intervalFn = () => {
				clearInterval(window.orderPaymentStatusInterval)
				setWaitingForPayment(false)
				dispatch({ type: 'ORDER_GET_PAYMENT_STATUS_RESET' })
			}
	
			window.orderPaymentStatusIntervalIndex = 0
	
			window.orderPaymentStatusInterval = setInterval(() => {
				window.orderPaymentStatusIntervalIndex++
				dispatch(getPaymentStatus(orderId))
				if (window.orderPaymentStatusIntervalIndex > 600) {
					intervalFn()
				}
			}, 1000)
		}
		
    }

	return (
        <Container className='p-5'>
            <Row className="mb-3">
                <Col xs={2} className='p-0'>
                    <Link className="p-0 my-3" to="/client/pendingorders">
                        <img src="../../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8} className='text-center'>
                    <h1 className='fs-18'>{t('admin.orders.pay')}</h1>
                </Col>
                <Col xs={2}></Col>
            </Row>
			<Row className="text-start my-3">
				<Col>
					<Card className='my-2'>
						<Card.Header>
							<Row>
								<Col className="text-start">
									<h2>{t('admin.orders.restaurant')}</h2>
									<h2><strong>{order?.restaurant}</strong></h2>
									<div>
										<strong>{t('admin.orders.hour')}<br/>
										{order?.hour+' - '+order?.date?.substr(8,2)+'/'+order?.orderAt?.substr(5,2)+'/'+order?.orderAt?.substr(0,4)}
										</strong>
									</div>
								</Col>
								<Col className="text-end">
									<div>
										<strong>
											{order?.orderAt?.substr(11,5)}<br/>
											{order?.orderAt?.substr(8,2)+'/'+order?.orderAt?.substr(5,2)+'/'+order?.orderAt?.substr(0,4)}
										</strong>
									</div>
									<div>
										<h2 className="mb-0"><strong>{t('admin.orders.order')}</strong></h2>
										<h3><strong>{order?.orderReference}</strong></h3>
									</div>
									<div>
										<strong>{t('client.menus.total')}</strong><br/>
										<strong>{order?.price?.toFixed(2)}€</strong>
									</div>
								</Col>
							</Row>
						</Card.Header>
						<Card.Body className='text-center'>
							{order?.firstdish?.name &&
								<Row className='mb-5 align-items-center'>
									<Col xs={12} className='text-center mb-4'>{t('admin.orders.firstdish')}</Col>
									{order?.firstdish?.photo && <Col><img className='w-100' src={order?.firstdish?.photo} alt={order?.firstdish?.name}/></Col>}
									<Col>
										<h2><strong>{order?.firstdish?.name}</strong><br/>{order?.firstdish?.supplement > 0 ? ` +${order?.firstdish?.supplement.toFixed(2)}€` : ''}</h2>
									</Col>
								</Row>
							}
							{order?.seconddish?.name &&
								<Row className='my-5 align-items-center'>
									<Col xs={12} className='text-center mb-4'>{t('admin.orders.seconddish')}</Col>
									{order?.seconddish?.photo && <Col><img className='w-100' src={order?.seconddish?.photo} alt={order?.seconddish?.name}/></Col>}
									<Col>
										<h2><strong>{order?.seconddish?.name}</strong><br/>{order?.seconddish?.supplement > 0 ? ` +${order?.seconddish?.supplement.toFixed(2)}€` : ''}</h2>
									</Col>
								</Row>
							}
							{order?.drink?.name &&
								<Row className='my-5 align-items-center'>
									<Col xs={12} className='text-center mb-4'>{t('admin.orders.drink')}</Col>
									{order?.drink?.photo && <Col><img className='w-100' src={order?.drink?.photo} alt={order?.drink?.name}/></Col>}
									<Col>
										<h2><strong>{order?.drink?.name}</strong><br/>{order?.drink?.supplement > 0 ? ` +${order?.drink?.supplement.toFixed(2)}€` : ''}</h2>
									</Col>
								</Row>
							}
							{order?.dessert?.name &&
								<Row className='my-5 align-items-center'>
									<Col xs={12} className='text-center mb-4'>{t('admin.orders.dessert')}</Col>
									{order?.dessert?.photo && <Col><img className='w-100' src={order?.dessert?.photo} alt={order?.dessert?.name}/></Col>}
									<Col>
										<h2><strong>{order?.dessert?.name}</strong><br/>{order?.dessert?.supplement > 0 ? ` +${order?.dessert?.supplement.toFixed(2)}€` : ''}</h2>
									</Col>
								</Row>
							}
							{
								order?.complements?.length > 0 &&
									<Row className='my-5 align-items-center'>
										<Col xs={12} className='text-center mb-3'>{t('admin.orders.complements')}</Col>
										{
											order?.complements?.map((complement, index) => (
												<Row key={index}>
													{complement?.photo && <Col className='mt-2'><img className='w-100' src={complement?.photo} alt={complement?.name}/></Col>}
													<Col className='mb-4'>
														<h2><strong>{complement?.name}</strong><br/>{complement?.price > 0 ? ` +${complement.price?.toFixed(2)}€` : ''}</h2>
													</Col>
												</Row>
											))
										}
									</Row>
							}
							{/* {
								!order?.isPaid && stripePromise && clientSecret && clientSecret !== "" &&
									<>
										<hr/>
										<div className='mt-3'>
											<Elements stripe={stripePromise} options={{ clientSecret }}>
												<StripeCheckoutForm order={order} clientSecret={clientSecret} user={client}/>
											</Elements>
										</div>
									</>
							} */}
							{
								!order?.isPaid && redsysParamsState &&
								<>
									
									<div className="col-12 py-3">
										{process.env.REACT_APP_PLATFORM === 'app'
											?
											<>
												<p>{t('client.orders.redirectBrowser')}</p>
												<a href={urlPago} target='_blank' className='btn btn-primary py-2' rel='noreferrer' onClick={handlePaymentLinkClick}>
													{
														waitingForPayment
														?
															<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
														:
															t('admin.orders.pay')
													}
												</a>
											</>
											:
											<>
												{/* Producción */}
												<form ref={formRef} autoComplete='off' target='_system' name="form" action="https://sis.redsys.es/sis/realizarPago" method="POST" onSubmit={handlePaymentLinkClick}>
												{/* Desarrollo */}
												{/* <form autoComplete='off' target='_system' name="form" action="https://sis-t.redsys.es:25443/sis/realizarPago" method="POST" onSubmit={handlePaymentLinkClick}> */}
													<input type="hidden" name="Ds_SignatureVersion" value={redsysParamsState.Ds_SignatureVersion} />
													<input type="hidden" name="Ds_MerchantParameters" value={redsysParamsState.Ds_MerchantParameters} />
													<input type="hidden" name="Ds_Signature" value={redsysParamsState.Ds_Signature} />
													<div className="d-grid gap-2">
														<Button type="submit" variant='primary'>
															{
																waitingForPayment
																?
																	<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
																:
																	t('admin.orders.pay')
															}
														</Button>
													</div>
												</form>
											</>
										}
									</div>
								</>
							}
						</Card.Body>
					</Card>
				</Col>
			</Row>
            <Modal show={waitingForPayment} centered backdrop="static" keyboard={false}>
                <Modal.Body className="text-center p-4">
                    <Spinner animation="border" variant="primary" className="mb-3" />
                    <h5 className="mb-3">Procesando el pago</h5>
                    {elapsedSeconds < 300
                        ? <p>Completa el pago en la ventana que se ha abierto.<br/>Esta página se actualizará automáticamente cuando el pago sea confirmado.</p>
                        : <p className="text-warning fw-bold">El pago está tardando más de lo esperado. ¿Completaste el pago en la ventana abierta?</p>
                    }
                    <p className="text-muted small mb-3">Tiempo restante: {formatCountdown(remainingSeconds)}</p>
                    <div className="d-flex gap-2 justify-content-center">
                        <Button variant="success" onClick={handleCheckNow}>Ya he pagado</Button>
                        <Button variant="outline-secondary" onClick={handleCancelPayment}>Cancelar</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </Container>
	)
}